import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom'
import { Url } from '../components/Url';
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout';
import ListPedidos from '../components/listPedidos';


const Categoria = () => {
    const [productos, setProductos] = useState([])
    const { modify, setModify } = useContext(ContextStates)
    let catParam = useParams()

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append('rubro', catParam.id);
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify, catParam])

    return (
        <Layout
            pagina={"Productos de la categoría "}
        >
            <div className='w-full pt-20 pb-20'>
                <div className={`w-full p-2 md:grid md:grid-flow-col md:gap-4 ${productos.length>3 ? 'md:grid-rows-2':'md:grid-rows-1' } `}>
                    {productos && productos.map((item, index) => (
                        <div key={index} className='col-span-1 shadow-2xl hover:shadow-3xl rounded-2xl'>
                        <Link to={`/producto/${item.id}`}>
                            <div className='hover:cursor-pointer'>
                                <img className='w-full rounded-t-2xl object-cover' src={Url + item.imagenes[0].imagen} alt={item.descripcion} />
                                <h3 className='text-center text-2xl font-bold mt-5 mb-2'>{item.descripcion}</h3>
                                <h3 className='text-center text-2xl font-bold mt-5 mb-2'>$ {parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</h3>
                            </div>
                        </Link>
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    )
}

export default Categoria